import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function matchPasswordValidator(password: string, confirmPassword: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
        const passwordControl = formGroup.get(password);
        const confirmPasswordControl = formGroup.get(confirmPassword);

        if (!passwordControl || !confirmPasswordControl) {
            return null;
        }

        const passwordsMismatch = passwordControl.value !== confirmPasswordControl.value;
        const confirmPasswordDirty = confirmPasswordControl.dirty && confirmPasswordControl.value.length > 0;

        if ((confirmPasswordDirty && passwordsMismatch) || (passwordControl.valid && passwordsMismatch)) {
            return { passwordMismatch: true };
        }

        return null;
    };
}
